import { useContext } from 'react';

import { ConfigureScenarioContext } from './ConfigureScenarioContext';

export const useConfigureScenarioContext = () => {
  return useContext(ConfigureScenarioContext);
};
